import React from "react";
import { appColors } from "../../utils/appTheme";

/**
 * Avatar. shape: "square" (cuadrado redondeado, estilo app) | "circle".
 * Muestra foto si hay photoURL, sino iniciales sobre fondo azul.
 */
const Avatar = ({
  initials = "",
  photoURL,
  shape = "square",
  size = 44,
  bg = appColors.blue,
  color = appColors.onBlue,
  style,
}) => {
  const radius = shape === "circle" ? "50%" : Math.round(size * 0.3);
  const common = {
    width: size,
    height: size,
    minWidth: size,
    borderRadius: radius,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    ...style,
  };

  if (photoURL) {
    return (
      <span style={common}>
        <img
          src={photoURL}
          alt={initials || "avatar"}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </span>
    );
  }

  return (
    <span
      style={{
        ...common,
        background: bg,
        color,
        fontSize: Math.round(size * 0.34),
        fontWeight: 400,
        letterSpacing: ".02em",
      }}
    >
      {initials}
    </span>
  );
};

export default Avatar;
